import { requestJson } from "./httpClient";
import type {
  AuthRequestUrlResponse,
  CalendarAllResponse,
  UserDetailsResponse,
  ValidateAuthTokenRequest,
  ValidateAuthTokenResponse,
  SimpleStatusResponse,
  AgentCreateOnceResponse,
  TokenUsageOverviewResponse,
  OAuthScope,
  InviteValidateRequest,
} from "./types";

/**
 * GET /v1/public/login/auth_request_url
 */
export async function getAuthRequestUrl(params: {
  scope: OAuthScope;
  redirectUri?: string;
  xEmail?: string;
}): Promise<AuthRequestUrlResponse> {
  const headers: Record<string, string> = {};
  if (params.xEmail) {
    headers["X-EMAIL"] = params.xEmail;
  }
  return requestJson<AuthRequestUrlResponse>("/v1/public/login/auth_request_url", {
    method: "GET",
    headers,
    query: {
      scope: params.scope,
      redirect_uri: params.redirectUri,
    },
  });
}

/**
 * POST /v1/public/login/validate_auth_token
 */
export async function validateAuthToken(
  payload: ValidateAuthTokenRequest
): Promise<ValidateAuthTokenResponse> {
  return requestJson<ValidateAuthTokenResponse>("/v1/public/login/validate_auth_token", {
    method: "POST",
    body: payload,
  });
}

/**
 * POST /v1/public/login/validate_sid
 */
export async function validateSid(headers: {
  xSid: string;
  xEmail: string;
}): Promise<SimpleStatusResponse> {
  return requestJson<SimpleStatusResponse>("/v1/public/login/validate_sid", {
    method: "POST",
    headers: {
      "X-SID": headers.xSid,
      "X-EMAIL": headers.xEmail,
    },
  });
}

/**
 * GET /v1/public/user/details
 */
export async function getUserDetails(headers: {
  xSid: string;
  xEmail: string;
}): Promise<UserDetailsResponse> {
  return requestJson<UserDetailsResponse>("/v1/public/user/details", {
    method: "GET",
    headers: {
      "X-SID": headers.xSid,
      "X-EMAIL": headers.xEmail,
    },
  });
}

/**
 * GET /v1/public/calendar/all
 */
export async function getCalendarAll(headers: {
  xSid: string;
  xEmail: string;
}): Promise<CalendarAllResponse> {
  return requestJson<CalendarAllResponse>("/v1/public/calendar/all", {
    method: "GET",
    headers: {
      "X-SID": headers.xSid,
      "X-EMAIL": headers.xEmail,
    },
  });
}

/**
 * POST /v1/public/agent/create_once
 */
export async function createAgentOnce(headers: {
  xSid: string;
  xEmail: string;
}): Promise<AgentCreateOnceResponse> {
  return requestJson<AgentCreateOnceResponse>("/v1/public/agent/create_once", {
    method: "POST",
    headers: {
      "X-SID": headers.xSid,
      "X-EMAIL": headers.xEmail,
    },
  });
}

/**
 * GET /v1/public/usage/token_usage_overview
 */
export async function getTokenUsageOverview(headers: {
  xSid: string;
  xEmail: string;
}): Promise<TokenUsageOverviewResponse> {
  return requestJson<TokenUsageOverviewResponse>("/v1/public/usage/token_usage_overview", {
    method: "GET",
    headers: {
      "X-SID": headers.xSid,
      "X-EMAIL": headers.xEmail,
    },
  });
}

/**
 * POST /v1/public/invite/validate
 */
export async function validateInviteCode(params: {
  xSid: string;
  xEmail: string;
  invite_code: string;
}): Promise<SimpleStatusResponse> {
  const body: InviteValidateRequest = { invite_code: params.invite_code.trim() };
  return requestJson<SimpleStatusResponse>("/v1/public/invite/validate", {
    method: "POST",
    headers: {
      "X-SID": params.xSid,
      "X-EMAIL": params.xEmail,
    },
    body,
  });
}
